import React from "react";
import { IBannerData } from "../../exports/interfaces";

const GalleryBanner = (props: { galleryBannerData: IBannerData[] }) => {
  return (
    <section className="page-header" style={{ marginTop: "71px" }}>
      <div
        className="page-header-bg"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${props?.galleryBannerData[0]?.attributes?.Image?.data?.attributes?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="container">
        <div className="page-header__inner">
          <h2>{props?.galleryBannerData[0]?.attributes?.Title}</h2>
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span>/</span>
            </li>
            <li className="active">Gallery</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default GalleryBanner;
